/*!
 *подключаем datepicker
 */
 
import "bootstrap-datepicker";
import("bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min.js");
import("bootstrap-select");

$.fn.datepicker.dates['ru'] = {
days:["Воскресенье","Понедельник","Вторник","Среда","Четверг","Пятница","Суббота"],daysShort:["Вск","Пнд","Втр","Срд","Чтв","Птн","Суб"],daysMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthsShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],today:"Сегодня",clear:"Очистить",format:"dd.mm.yyyy",weekStart:1,monthsTitle:"Месяцы"
};
$(document).ready(function () {
document.addEventListener("turbolinks:load", function () {
  $(".datepicker").datepicker();
});
$(".datepicker")
  .datepicker({
    language: "ru",format:"dd.mm.yyyy",weekStart:1
  })
  .on("changeDate", function (e) {
    window.location =
      window.location.pathname + `?starts_at=${e.format()}&h=${gon.cat_id}`;
  });
  // $.datepicker.setDefaults($.datepicker.dates['ru']);
// yearRange : $('.datepicker_year').attr('data-year-range')
$(".year_date").click(function () {
  window.location =
    window.location.pathname + `?starts_at=` + $(this).attr("dateyear");
});
$("select").selectpicker();
});